var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title-wrapper",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", { staticClass: "dialog-title-text" }, [
                _vm._v(
                  _vm._s(
                    _vm.cashOutData.status === 8
                      ? _vm.$t("merchantAccount.confirm_cash_out")
                      : _vm.$t("system.withdraw_details")
                  )
                ),
              ]),
              _c(
                "el-tag",
                {
                  staticClass: "status-tag",
                  attrs: {
                    type: _vm.getStatusType(_vm.cashOutData.status),
                    size: "small",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getStatusText(_vm.cashOutData.status)) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "diglog-container" },
            [
              _c("div", { staticClass: "header-line" }),
              _c(
                "el-form",
                {
                  ref: "confirmForm",
                  staticStyle: { "margin-top": "18px" },
                  attrs: { model: _vm.formData, "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("data.withdrawal_amount"),
                                prop: "withdraw_amount",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-item" },
                                [
                                  !_vm.isEditWithdrawAmount
                                    ? _c(
                                        "span",
                                        { staticClass: "amount-value" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.cashOutData.source_currency
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.formData.withdraw_amount
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c("el-input", {
                                        staticClass: "simple-input",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          clearable: "",
                                        },
                                        on: {
                                          input: _vm.handleWithdrawAmountInput,
                                        },
                                        model: {
                                          value: _vm.formData.withdraw_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "withdraw_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.withdraw_amount",
                                        },
                                      }),
                                  _vm.canEditAmount && _vm.isEditWithdrawAmount
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-cancel-btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEditWithdrawAmount(
                                                "close"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Cancel ")]
                                      )
                                    : _vm._e(),
                                  _vm.canEditAmount && _vm.isEditWithdrawAmount
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-confirm-btn",
                                          on: {
                                            click: _vm.handleEditWithdrawAmount,
                                          },
                                        },
                                        [_vm._v(" Confirm ")]
                                      )
                                    : _vm._e(),
                                  _vm.canEditAmount && !_vm.isEditWithdrawAmount
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          on: {
                                            click: _vm.handleEditWithdrawAmount,
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "edit-icon",
                                            attrs: {
                                              src: require("@/assets/img/cash_out_edit.png"),
                                              alt: "edit",
                                            },
                                          }),
                                          _c("span", [_vm._v("Edit")]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("data.amount_received") },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-show-info amount-value" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.cashOutData.currency) +
                                      " " +
                                      _vm._s(_vm.displayArrivalAmount)
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(_vm._s(_vm.$t("data.exchange_rate")) + ":"),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.cashOutData.exchange_rate
                                  ? "1.00 USD = " +
                                      _vm.cashOutData.exchange_rate +
                                      " " +
                                      _vm.cashOutData.source_currency
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("merchant.service_fee")) + ":"
                            ),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.cashOutData.currency) +
                                " " +
                                _vm._s(
                                  _vm.formatAmount(_vm.cashOutData.service_fee)
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "diglog-container" }, [
                    _c("div", {
                      staticClass: "header-line",
                      staticStyle: { margin: "10px 0" },
                    }),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("merchant.account_bank")) + ":"
                            ),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(_vm._s(_vm.cashOutData.bank_name || "-")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("merchant.account_num")) + ":"
                            ),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.cashOutData.bank_account_num || "-")
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("merchant.account_name")) + ":"
                            ),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.cashOutData.bank_account_name || "-")
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticClass: "info-row" }, [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("merchantAccount.operator")) + ":"
                            ),
                          ]),
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(_vm._s(_vm.cashOutData.operator || "-")),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm.showExchangeRateAndInvoice
                    ? [
                        _c("div", {
                          staticStyle: {
                            margin: "10px 0",
                            "border-bottom": "2px solid #D3D7DF",
                          },
                        }),
                        _c("div", { staticClass: "section-title" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("data.invoice_image")) + " "
                          ),
                        ]),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "div",
                                    [
                                      _vm.attachments.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "uploaded-images-container",
                                            },
                                            _vm._l(
                                              _vm.sortedAttachments,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "uploaded-image-item",
                                                  },
                                                  [
                                                    _vm.isImg(
                                                      item.attachment_content
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "image-wrapper",
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              staticStyle: {
                                                                height: "120px",
                                                                width: "120px",
                                                              },
                                                              attrs: {
                                                                src: item.attachment_content_oss_url,
                                                                "preview-src-list":
                                                                  _vm.allImageUrls,
                                                                fit: "cover",
                                                              },
                                                            }),
                                                            _vm.canDeleteAttachment(
                                                              item.originalIndex
                                                            )
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "delete-icon",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.onClickRemoveBtn(
                                                                            item.originalIndex
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-close",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "file-item",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-document",
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                class: [
                                                                  "file-name",
                                                                ],
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleDownloadFile(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.attachment_name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm.canDeleteAttachment(
                                                              item.originalIndex
                                                            )
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "el-icon-close file-delete-btn",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onClickRemoveBtn(
                                                                          item.originalIndex
                                                                        )
                                                                      },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm.canUploadInvoice
                                        ? _c(
                                            "MultipleUploadFile",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  "limit-num":
                                                    _vm.maxAttachments,
                                                  list: _vm.attachments,
                                                  "file-dir":
                                                    "MERCHANT_WITHDRAW_INVOICE",
                                                },
                                                on: {
                                                  templateFileSuccess:
                                                    _vm.templateFileSuccess,
                                                },
                                              },
                                              _vm.$listeners
                                            )
                                          )
                                        : _vm._e(),
                                      _vm.$store.getters.curCountry
                                        .country_code === "MY"
                                        ? _c(
                                            "div",
                                            { staticClass: "invoice-tips" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "tip-item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "tip-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Item Description:"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "tip-value",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "merchant settlement"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "tip-item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "tip-label",
                                                    },
                                                    [_vm._v("To:")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "tip-value",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Micro Bluetech Sdn Bhd"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c("div", { staticClass: "diglog-container" }, [
            _c("div", {
              staticClass: "header-line",
              staticStyle: { margin: "10px 0" },
            }),
          ]),
          _c(
            "div",
            { staticClass: "diglog-container" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("merchantAccount.create_time")) + ":"
                        ),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(_vm.cashOutData.create_time)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("merchantAccount.update_time")) + ":"
                        ),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(_vm.cashOutData.update_time)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-row" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("merchantAccount.complete_time")) + ":"
                        ),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(
                              _vm.cashOutData.transaction_return_time
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.showFooter
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _vm.showConfirmBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "info",
                            disabled: _vm.submiting,
                            loading: _vm.submiting,
                          },
                          on: { click: _vm.handleConfirmCashOut },
                        },
                        [_vm._v(_vm._s(_vm.submitBtnText))]
                      )
                    : _vm._e(),
                  _vm.showCancelBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: _vm.isPendingPricing ? "primary" : "",
                            plain: _vm.isPendingPricing,
                          },
                          on: { click: _vm.handleCancelCashOut },
                        },
                        [_vm._v(_vm._s(_vm.cancelBtnText))]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }